import React from 'react';
import classNames from 'classnames';
import { Box } from '@stitch-fix/mode-react';
import {
  CloudinaryImageWrapper,
  type CloudinaryImageFields,
} from '../CloudinaryImageWrapper';
import { JsonRteRenderer } from '../JsonRteRenderer';
import { Header, type HeaderProps } from '../Header';
import styles from './styles.module.scss';
import type { ContentStackJSONRichText } from '../../utils/requests/contentstack/contentStackZodSchema';
import { MODE_MIN_WIDTH } from '../../utils/values/mediaQueries';

export type ContentGalleryProps = {
  layout: 'short' | 'tall';
  topLeftImage: CloudinaryImageFields;
  topRightImage: CloudinaryImageFields;
  bottomLeftImage: CloudinaryImageFields;
  bottomRightImage: CloudinaryImageFields;
  text: ContentStackJSONRichText;
  contentGalleryHeader?: HeaderProps;
};

export const ContentGallery = ({
  layout,
  topLeftImage,
  topRightImage,
  bottomLeftImage,
  bottomRightImage,
  text,
  contentGalleryHeader,
}: ContentGalleryProps) => {
  return (
    <Box as="section" className={styles.componentContainer}>
      {contentGalleryHeader && <Header {...contentGalleryHeader} />}
      <Box
        className={classNames(styles.contentContainer, {
          [styles.short]: layout === 'short',
        })}
      >
        <Box className={classNames(styles.imagesContainer, styles.topImages)}>
          <Box className={styles.imageContainer}>
            <CloudinaryImageWrapper
              alt={topLeftImage.alt}
              src={topLeftImage.src}
              sources={{ sm: 241, md: 336 }}
              objectFit="cover"
              cloudinaryAsset={topLeftImage.cloudinaryAsset}
              maxContainerWidth={776}
              sizes={[{ minWidth: MODE_MIN_WIDTH.sm, fluidWidth: 40 }]}
              imageProps={{
                loading: 'lazy',
                style: { height: '100%', objectFit: 'cover' },
              }}
            />
          </Box>
          <Box className={styles.imageContainer}>
            <CloudinaryImageWrapper
              alt={topRightImage.alt}
              src={topRightImage.src}
              sources={{ sm: 327, md: 456 }}
              objectFit="cover"
              cloudinaryAsset={topRightImage.cloudinaryAsset}
              maxContainerWidth={776}
              sizes={[{ minWidth: MODE_MIN_WIDTH.sm, fluidWidth: 60 }]}
              imageProps={{
                loading: 'lazy',
                style: { height: '100%', objectFit: 'cover' },
              }}
            />
          </Box>
        </Box>
        <Box
          className={classNames(styles.imagesContainer, styles.bottomImages)}
        >
          <Box className={styles.imageContainer}>
            <CloudinaryImageWrapper
              alt={bottomLeftImage.alt}
              src={bottomLeftImage.src}
              sources={{ sm: 327, md: 456 }}
              objectFit="cover"
              cloudinaryAsset={bottomLeftImage.cloudinaryAsset}
              maxContainerWidth={776}
              sizes={[{ minWidth: MODE_MIN_WIDTH.sm, fluidWidth: 60 }]}
              imageProps={{
                loading: 'lazy',
                style: { height: '100%', objectFit: 'cover' },
              }}
            />
          </Box>
          <Box className={styles.imageContainer}>
            <CloudinaryImageWrapper
              alt={bottomRightImage.alt}
              src={bottomRightImage.src}
              sources={{ sm: 241, md: 336 }}
              objectFit="cover"
              cloudinaryAsset={bottomRightImage.cloudinaryAsset}
              sizes={[{ minWidth: MODE_MIN_WIDTH.sm, fluidWidth: 40 }]}
              maxContainerWidth={776}
              imageProps={{
                loading: 'lazy',
                style: { height: '100%', objectFit: 'cover' },
              }}
            />
          </Box>
        </Box>

        <Box className={styles.reasonsContainer}>
          <Box className={styles.reasonsContent}>
            <JsonRteRenderer data={text} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
